import React from 'react';
import * as S from './styled';
import { checkKey, KEY } from '../../utils/inputEvents';

const RadioButton = ({
  text,
  checked,
  onChange,
  bold,
  dark,
  description,
  icon,
  alignLeft,
  invalid,
}) => {
  const handleKeyPress = e => {
    if (
      checkKey(e, KEY.ENTER.code, KEY.ENTER.name) ||
      checkKey(e, KEY.SPACE.code, KEY.SPACE.name)
    ) {
      onChange();
    }
  };

  return (
    <S.RadioButtonWrapper
      onClick={onChange}
      tabIndex="0"
      onKeyDown={handleKeyPress}
      description={description}
      data-testid="radiobutton-wrapper"
      alignLeft={alignLeft}
    >
      <S.StyledLabel bold={bold} dark={dark} invalid={invalid}>
        <S.RadioButton invalid={invalid}>
          {checked &&
            (icon ? (
              <S.IconCheck className={`icon icon-${icon}`} />
            ) : (
              <S.Check data-testid="check" />
            ))}
        </S.RadioButton>
        <span>{text}</span>
      </S.StyledLabel>
      {description && (
        <S.Description invalid={invalid}>{description}</S.Description>
      )}
    </S.RadioButtonWrapper>
  );
};
export default RadioButton;
